// extracted by mini-css-extract-plugin
export default {"item":"SignStatus_item__MidQW","signed":"SignStatus_signed__du+Vq","wait":"SignStatus_wait__4D+eg","rejected":"SignStatus_rejected__TavMG"};